import {
    ArrowRightCircle,
    BgCar,
    BgCity,
    BulbIcon,
    EyeIcon,
    EyeIconHovered, LinkForward,
    Pause,
    Play,
    Refresh,
    UsersIcon,
    WarningIcon,
    WireIcon
} from "@/components/icons";
import {Link} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {QueryObserverResult} from "@tanstack/react-query";
import {StatsResponseDto} from "@/lib/api";
import {StatsResponse} from "@/hooks/useStats";

const FollowLinkIcon = () => {
    return (
        <div className="card-icon-container" role="presentation">
            <span className="in-active-icon"><ArrowRightCircle color={"var(--color-green)"}/></span>
            <span className="active-icon"><ArrowRightCircle strokeWidth={1.8} color={"var(--color-green)"}/></span>
        </div>)
}

export function HeadBanner({
                               refetch,
                               stats,
                               loading,
                               error
                           }: {
    refetch: () => Promise<QueryObserverResult<StatsResponseDto, Error>>
    loading: boolean,
    error: Error | null,
    stats: StatsResponse,

}) {
    const {activeDevices, unsupportedDevices, offlineDevices, chargingDevices} = stats;
    const LS_BG_PAUSED = "dashboardBgPaused";

    const [bgPaused, setBgPaused] = useState(() => localStorage.getItem(LS_BG_PAUSED) !== "false");
    useEffect(() => localStorage.setItem(LS_BG_PAUSED, String(bgPaused)), [bgPaused]);

    return <div className="dashboard-cards-wrap">
        <div className="dashboard-bg-controls">
            <button
                type="button"
                onClick={refetch}
                className="dashboard-bg-toggle"
                title="Refresh stats"
            >
                <Refresh size={24} strokeWidth={1.5}/>
            </button>
            <button
                type="button"
                onClick={() => setBgPaused((prev) => !prev)}
                className="dashboard-bg-toggle"
                title={bgPaused ? "Play background" : "Pause background"}
            >
                {bgPaused ? (
                    <Play size={24} strokeWidth={1.5}/>
                ) : (
                    <Pause size={24} strokeWidth={1.5}/>
                )}
            </button>
        </div>
        <div className="dashboard-cards-bg" style={bgPaused ? {animationPlayState: "paused"} : undefined}>
            <BgCity/>
            <BgCity/>
        </div>
        <div className="dashboard-cards-container">
            <div className="each-card-container">

                <div className="card-details">
                    <p className="text-xs uppercase text-slate-500">Active Units</p>
                    <h1 className="text-3xl text-primary">{activeDevices || 0}</h1>
                    <p className="text-xs text-slate-400">online recently</p>
                </div>
                <div className="card-image-wrap">
                    <UsersIcon className="card-image"/>
                    <div className="card-icons-wrap">
                        <Link to="/devices?status=standby,charging,connected,ready">
                            <FollowLinkIcon/>
                        </Link>

                    </div>
                </div>
            </div>
            <div className="each-card-container">

                <div className="card-details">
                    <p className="text-xs uppercase text-slate-500">Charging</p>
                    <h1 className="text-3xl text-teal-500">{chargingDevices}</h1>
                    <p className="text-xs text-slate-400/80">currently charging</p>
                </div>
                <div className="card-image-wrap">
                    <BulbIcon className="card-image"/>
                    <div className="card-icons-wrap">
                        <Link to="/devices?status=charging">
                            <FollowLinkIcon/>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="each-card-container">

                <div className="card-details">
                    <p className="text-xs uppercase text-slate-500">Offline</p>
                    <h1 className="text-3xl text-slate-500">{offlineDevices}</h1>
                    <p className="text-xs text-slate-400">no heartbeat</p>
                </div>
                <div className="card-image-wrap">
                    <WireIcon className="card-image"/>
                    <div className="card-icons-wrap">
                        <Link to="/devices?status=offline">
                            <FollowLinkIcon/>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="each-card-container">

                <div className="card-details">
                    <p className="text-xs uppercase text-slate-500">Need Attention</p>
                    <h1 className={`text-3xl ${unsupportedDevices > 0 ? "text-rose-500" : "text-slate-500"}`}>{unsupportedDevices}</h1>
                </div>
                <div className="card-image-wrap">
                    <WarningIcon className="card-image"/>
                    <div className="card-icons-wrap">
                        <Link to="/devices?status=unsupported,error,blocked">
                            <FollowLinkIcon/>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        <BgCar/>
    </div>;
}